import React, { useState } from "react"
import styled from "styled-components"
import ButtonForm from "./ButtonForm"
import IconLeeds from "../../images/list-icon.png"
import IconYork from "../../images/list-icon-york.png"
import IconManchester from "../../images/list-icon-manchester.png"
import DD from "../../images/dd.png"
import parse from "html-react-parser"

const IncreaseSignupsCTAWrap = styled.section`
  position: relative;
  background: var(--grey) !important;
  margin-top: ${props => (props.marginTop === false ? "0" : "4rem")};
  padding: 4rem 0;

  @media only screen and (min-width: 1024px) {
    padding: 8rem 0 0 0;
    margin-top: ${props => (props.marginTop === false ? "0" : "8rem")};
  }

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    background-color: ${props => `var(--${props.bgColor})`};
    width: 100%;
    height: ${props => props.bgSize};
    ${props => props.bgPosition}:0;
    z-index: 0;
  }

  .wrapper {
    z-index: 1;
  }

  .heading--l {
    margin-bottom: 4rem;
  }

  .cta-form-block {
    width: 100%;
    padding: 2rem;
    background: var(--white);
    display: flex;
    flex-wrap: wrap;

    @media only screen and (min-width: 1024px) {
      flex-wrap: nowrap;
      padding: 4rem;
    }

    .form-wrap {
      width: 100%;
      order: 2;

      @media only screen and (min-width: 1024px) {
        width: 50%;
        order: 1;
        margin-right: 4rem;
      }

      select {
        background-image: url(${DD});
        background-repeat: no-repeat;
        background-size: 10px;
        background-position: calc(100% - 1rem) center;
      }

      select,
      input[type="text"],
      input[type="email"],
      textarea,
      .checkboxes {
        width: 100%;
        margin-bottom: 0.75rem;
        padding: 0.5rem;
        border: 1px solid var(--black);
        transition: 0.5s all ease-in-out;

        &::placeholder {
          color: var(--black);
        }

        &:focus {
          outline: none;
          background-color: var(--black);
          color: var(--white);

          &::placeholder {
            color: var(--white);
          }
        }
      }

      .checkboxes {
        padding: 1rem 0.5rem;

        label,
        div {
          margin-bottom: 1rem;
          position: relative;
          display: block;

          label {
            width: auto;
            display: inline-block;
            margin-bottom: 0;
          }

          input {
            margin-right: 0.5rem;
            /* opacity:0; */
          }
        }

        div:last-of-type {
          margin-bottom: 0;
          label {
            margin-bottom: 0;
          }
        }

        /* Customize the label (the container) */
        .container {
          display: block;
          position: relative;
          padding-left: 30px;
          margin-bottom: 1rem;
          cursor: pointer;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }

        /* Hide the browser's default checkbox */
        .container input {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 20px;
          width: 20px;
          left: 0;
          top: 0;
          z-index: 100;
        }

        /* Create a custom checkbox */
        .checkmark {
          position: absolute;
          top: 0;
          left: 0;
          height: 20px;
          width: 20px;
          background-color: var(--grey);
          transition: 0.5s all ease-in-out;
        }

        /* On mouse-over, add a grey background color */
        .container:hover input ~ .checkmark {
          background-color: var(--charcoal);
        }

        /* When the checkbox is checked, add a blue background */
        .container input:checked ~ .checkmark {
          background-color: var(--brandColor);
        }

        /* Create the checkmark/indicator (hidden when not checked) */
        .checkmark:after {
          content: "";
          position: absolute;
          display: none;
        }

        /* Show the checkmark when checked */
        .container input:checked ~ .checkmark:after {
          display: block;
        }
      }
    }

    .info-wrap {
      width: 100%;
      order: 1;
      margin-bottom: 2rem;

      @media only screen and (min-width: 1024px) {
        margin-bottom: 0;
        width: 50%;
        order: 2;
      }

      ul {
        list-style: none;
        padding-left: 3rem;

        li {
          line-height: 1.5rem;
          margin-bottom: 2rem;
          position: relative;

          &:before {
            content: "";
            width: 2rem;
            height: 2rem;
            position: absolute;
            top: 0;
            left: -3rem;
            background-image: url(${process.env.GATSBY_SITENAME === "Leeds"
              ? IconLeeds
              : process.env.GATSBY_SITENAME === "York"
              ? IconYork
              : process.env.GATSBY_SITENAME === "Leeds"
              ? IconManchester
              : " "});
            background-size: cover;
          }
        }
      }
    }

    .heading {
      font-size: 1.3rem;
      font-family: var(--font-bold);
      margin-bottom: 2rem;
    }

    .text {
      p {
        line-height: 1.5rem;
      }
    }
  }
`

export default function FormCTA({
  ctaHeading,
  ctaText,
  formHeading,
  sectionHeading,
  formBuilder,
  formName,
  bgSize,
  bgColor,
  bgPosition,
  marginTop,
  formButtonText,
}) {
  const [option, setOption] = useState(undefined)

  var containsFileUpload = false
  for (var i = 0; i < formBuilder.length; i++) {
    if (formBuilder[i].typeFieldType === "file") {
      containsFileUpload = true
      break
    }
  }

  return (
    <IncreaseSignupsCTAWrap
      bgSize={bgSize}
      bgColor={bgColor}
      bgPosition={bgPosition}
      marginTop={marginTop}
    >
      <div className="wrapper">
        <div className="heading--l">{sectionHeading}</div>
        <div className="cta-form-block">
          <div className="form-wrap">
            <div className="heading">{formHeading}</div>
            <div className="form">
              {containsFileUpload === false ? (
                <form
                  action="https://getform.io/f/f3f42b17-8acd-4c73-a4d8-6723f2274197"
                  method="POST"
                >
                  {formBuilder.map((formItem, index) => {
                    return formItem.typeFieldType === "text" ? (
                      <input
                        key={formItem.label + index}
                        type="text"
                        name={formName + "-" + formItem.label}
                        required
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "email" ? (
                      <input
                        key={formItem.label + index}
                        type="email"
                        name={formName + "-" + formItem.label}
                        required
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "textarea" ? (
                      <textarea
                        key={formItem.label + index}
                        rows="10"
                        name={formName + "-" + formItem.label}
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "dropdown" ? (
                      <select
                        key={formItem.label + index}
                        name={formName + "-" + formItem.label}
                        value={option === undefined ? formItem.label : option}
                        onChange={e => {
                          setOption(e.target.value)
                        }}
                      >
                        <option value={formItem.label} disabled>
                          {formItem.label}
                        </option>
                        {formItem.options.map((option, index) => {
                          return (
                            <option
                              key={option.option.slug + "-" + index}
                              value={option.option}
                            >
                              {option.option}
                            </option>
                          )
                        })}
                      </select>
                    ) : formItem.typeFieldType === "checkbox" ? (
                      <div key={formItem.label + index} className="checkboxes">
                        <label htmlFor="checkboxes">{formItem.label}</label>
                        {formItem.options.map((option, index) => {
                          return (
                            <div
                              key={option.option.slug + "-" + index}
                              className="container"
                            >
                              {option.option}
                              <input
                                type="checkbox"
                                id={option.option}
                                name={
                                  formName +
                                  "-" +
                                  formItem.label +
                                  "-" +
                                  option.option
                                }
                              />
                              <span className="checkmark"></span>
                            </div>
                          )
                        })}
                      </div>
                    ) : formItem.typeFieldType === "file" ? (
                      <div key={formItem.label + index} className="checkboxes">
                        <label htmlFor="checkboxes">{formItem.label}</label>
                        <input
                          key={formItem.label + index}
                          name={formName + "-" + formItem.label}
                          required
                          placeholder={formItem.label}
                          type="file"
                        ></input>
                      </div>
                    ) : (
                      ""
                    )
                  })}
                  <input
                    key={formName}
                    name={formName}
                    required
                    hidden
                    value={formName}
                    type="text"
                  ></input>
                  <ButtonForm
                    buttonBgColor={"white"}
                    buttonBgColorHover={"yellow"}
                    buttonTextColor={"black"}
                    buttonTextColorHover={"black"}
                    buttonBorderColor={"black"}
                    text={
                      formButtonText !== null ? formButtonText : "Enquire now"
                    }
                  />
                </form>
              ) : (
                <form
                  action="https://getform.io/f/f3f42b17-8acd-4c73-a4d8-6723f2274197"
                  method="POST"
                  encType="multipart/form-data"
                >
                  {formBuilder.map((formItem, index) => {
                    return formItem.typeFieldType === "text" ? (
                      <input
                        key={formItem.label + index}
                        type="text"
                        name={formName + "-" + formItem.label}
                        required
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "email" ? (
                      <input
                        key={formItem.label + index}
                        type="email"
                        name={formName + "-" + formItem.label}
                        required
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "textarea" ? (
                      <textarea
                        key={formItem.label + index}
                        rows="10"
                        name={formName + "-" + formItem.label}
                        placeholder={formItem.label}
                      />
                    ) : formItem.typeFieldType === "dropdown" ? (
                      <select
                        key={formItem.label + index}
                        name={formName + "-" + formItem.label}
                        value={option === undefined ? formItem.label : option}
                        onChange={e => {
                          setOption(e.target.value)
                        }}
                      >
                        <option value={formItem.label} disabled>
                          {formItem.label}
                        </option>
                        {formItem.options.map((option, index) => {
                          return (
                            <option
                              key={option.option.slug + "-" + index}
                              value={option.option}
                            >
                              {option.option}
                            </option>
                          )
                        })}
                      </select>
                    ) : formItem.typeFieldType === "checkbox" ? (
                      <div key={formItem.label + index} className="checkboxes">
                        <label htmlFor="checkboxes">{formItem.label}</label>
                        {formItem.options.map((option, index) => {
                          return (
                            <div
                              key={option.option.slug + "-" + index}
                              className="container"
                            >
                              {option.option}
                              <input
                                type="checkbox"
                                id={option.option}
                                name={formName + "-" + option.option}
                              />
                              <span className="checkmark"></span>
                            </div>
                          )
                        })}
                      </div>
                    ) : formItem.typeFieldType === "file" ? (
                      <div key={formItem.label + index} className="checkboxes">
                        <label htmlFor="checkboxes">{formItem.label}</label>
                        <input
                          key={formItem.label + index}
                          name={formName + "-" + formItem.label}
                          required
                          placeholder={formItem.label}
                          type="file"
                        ></input>
                      </div>
                    ) : (
                      ""
                    )
                  })}
                  <ButtonForm
                    buttonBgColor={"white"}
                    buttonBgColorHover={"yellow"}
                    buttonTextColor={"black"}
                    buttonTextColorHover={"black"}
                    buttonBorderColor={"black"}
                    text={
                      formButtonText !== null ? formButtonText : "Enquire now"
                    }
                  />
                </form>
              )}
            </div>
          </div>
          <div className="info-wrap">
            <div className="heading">{ctaHeading}</div>

            <div className="text">{parse(ctaText)}</div>
          </div>
        </div>
      </div>
    </IncreaseSignupsCTAWrap>
  )
}
